import React from "react";
import PromineoModalWithLoader from "components/common/controls/modal/PromineoModalWithLoader";

interface Props {
  children: React.ReactChild;
  title: string;
  isLoading: boolean;
  onClose: () => void;
}

export default function UserEditorModal(props: Props) {
  const { title, children, onClose, isLoading } = props;
  return (
    <PromineoModalWithLoader
      isLoading={isLoading}
      title={title}
      visible={true}
      onClose={onClose}
      maxWidth="471px"
      height="auto"
      displayDefaultActions={false}
    >
      {children}
    </PromineoModalWithLoader>
  );
}
